import React, { useEffect } from 'react'
import Form2 from './Form'
import { useSelector } from 'react-redux';
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader';
import { Link, useParams } from 'react-router-dom';
import blogList from '../../api/blogList';
import { Helmet } from 'react-helmet-async';

function BlogDetail() {
    let { id } = useParams();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    let selectedBlog = blogList.find((item) => item.url == id);
    return (
        <>
            <Helmet>
                <title>Inspectiver | {selectedBlog.metaTitle}</title>
                <meta name="keywords" content={selectedBlog.keywords.join(", ")} />
                <meta name="description" content={selectedBlog.description} />
                <link rel="canonical" href={"/" + selectedBlog.url} />
            </Helmet>
            <HerosectionHeader folder1={"pages"} folder2={"Blog"} name={selectedBlog.title} style={{ fontSize: "2rem" }} />
            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {selectedBlog &&
                                <div className="card border-0 bg-transparent">
                                    <img className="card-img-top shadow" src={require(`../../assets/images/blog/${selectedBlog.image.split('/')[3]}`)} alt="Image1" />
                                    <div className="card-body pt-5 px-0">
                                        {/* <div>
                                            <div className="d-inline-block bg-light text-center px-2 py-1 rounded me-2">{selectedBlog.date}</div> <div className="d-inline-block btn-link"></div>
                                        </div> */}
                                        <h2 className="h4 my-4">
                                            <div className="link-title">{selectedBlog.title}</div>
                                        </h2>
                                        <div dangerouslySetInnerHTML={{ __html: selectedBlog.content }} >

                                        </div>
                                    </div>


                                    <div className="d-md-flex justify-content-between">
                                        <div className="d-flex align-items-center">
                                        </div>
                                        <div className="d-flex align-items-center text-md-end mt-5 mt-md-0">
                                            <h6 className="mb-0 me-4">Tags: </h6>
                                            <ul className="list-inline mb-0">
                                                {selectedBlog?.tags?.map(tag => <li key={tag} className="list-inline-item">
                                                    <Link className="btn-link rounded d-inline-block p-2 bg-light m-1 " to="/">{tag}</Link>
                                                </li>)}
                                            </ul>
                                        </div>
                                    </div>
                                    <div>
                                        <Link className="btn btn-dark " to="/quotation">Order Your Inspection</Link>
                                    </div>
                                    <div />
                                </div>}

                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default BlogDetail
